import React from 'react';
import { SMAKEN_LOGO } from '../data/smaken';
interface LogoProps {
  /** Height utility for the wordmark, e.g. "h-10". */
  className?: string;
  /**
   * 'plain' drops the logo straight onto whatever is behind it.
   * 'block' sets it on its own paper panel, for dark surfaces where the
   * red and blue letters would otherwise lose contrast.
   */
  tone?: 'plain' | 'block';
}

/**
 * The Smaken som baken wordmark. Always shown whole and contained — the
 * hand-drawn letters are never cropped, restretched or redrawn.
 */
export function Logo({
  className = 'h-10',
  tone = 'plain'
}: LogoProps) {
  const mark = <img src={SMAKEN_LOGO} alt="Smaken som baken" className={`w-auto max-w-full object-contain object-left ${className}`} style={{
    width: "341px",
    height: "321px"
  }} data-id="element-667" data-mp="dreervg5jt8j" />;
  if (tone === 'block') {
    return <span className="inline-block bg-papper px-4 py-3" data-id="element-668" data-mp="2ygu1ofc92xsw">{mark}</span>;
  }
  return mark;
}